import increaseOpacity from './increase-opacity';
import reduceOpacity from './reduce-opacity';
import reduceColorPointByRatio from './reduce-color-point-by-ratio';
import increaseColorPointByRatio from './increase-color-point-by-ratio';
import reduceColorPointByStep from './reduce-color-point-by-step';
import increaseColorPointByStep from './increase-color-point-by-step';

export default {
  reduceOpacity,
  increaseOpacity,
  reduceColorPointByRatio,
  increaseColorPointByRatio,
  reduceColorPointByStep,
  increaseColorPointByStep,
};
